import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import axios from 'axios';
export const getInspectionRemoteSubmissionLocations = (inspectionId, params, options) => {
    return axios.get(`/api/v1/inspections/${inspectionId}/remote-submission-locations`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetInspectionRemoteSubmissionLocationsQueryKey = (inspectionId, params) => {
    return [`/api/v1/inspections/${inspectionId}/remote-submission-locations`, ...(params ? [params] : [])];
};
export const getGetInspectionRemoteSubmissionLocationsQueryOptions = (inspectionId, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionRemoteSubmissionLocationsQueryKey(inspectionId, params);
    const queryFn = ({ signal }) => getInspectionRemoteSubmissionLocations(inspectionId, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionRemoteSubmissionLocations(inspectionId, params, options) {
    const queryOptions = getGetInspectionRemoteSubmissionLocationsQueryOptions(inspectionId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetInspectionRemoteSubmissionLocationsSuspenseQueryOptions = (inspectionId, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionRemoteSubmissionLocationsQueryKey(inspectionId, params);
    const queryFn = ({ signal }) => getInspectionRemoteSubmissionLocations(inspectionId, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionRemoteSubmissionLocationsSuspense(inspectionId, params, options) {
    const queryOptions = getGetInspectionRemoteSubmissionLocationsSuspenseQueryOptions(inspectionId, params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getRemoteSubmissionInvites = (inspectionId, params, options) => {
    return axios.get(`/api/v1/inspections/${inspectionId}/remote-submission-invites`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetRemoteSubmissionInvitesQueryKey = (inspectionId, params) => {
    return [`/api/v1/inspections/${inspectionId}/remote-submission-invites`, ...(params ? [params] : [])];
};
export const getGetRemoteSubmissionInvitesQueryOptions = (inspectionId, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRemoteSubmissionInvitesQueryKey(inspectionId, params);
    const queryFn = ({ signal }) => getRemoteSubmissionInvites(inspectionId, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetRemoteSubmissionInvites(inspectionId, params, options) {
    const queryOptions = getGetRemoteSubmissionInvitesQueryOptions(inspectionId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetRemoteSubmissionInvitesSuspenseQueryOptions = (inspectionId, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRemoteSubmissionInvitesQueryKey(inspectionId, params);
    const queryFn = ({ signal }) => getRemoteSubmissionInvites(inspectionId, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetRemoteSubmissionInvitesSuspense(inspectionId, params, options) {
    const queryOptions = getGetRemoteSubmissionInvitesSuspenseQueryOptions(inspectionId, params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllInspections = (params, options) => {
    return axios.get(`/api/v1/inspections/listing`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetAllInspectionsQueryKey = (params) => {
    return [`/api/v1/inspections/listing`, ...(params ? [params] : [])];
};
export const getGetAllInspectionsQueryOptions = (params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllInspectionsQueryKey(params);
    const queryFn = ({ signal }) => getAllInspections(params, { signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllInspections(params, options) {
    const queryOptions = getGetAllInspectionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllInspectionsSuspenseQueryOptions = (params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllInspectionsQueryKey(params);
    const queryFn = ({ signal }) => getAllInspections(params, { signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllInspectionsSuspense(params, options) {
    const queryOptions = getGetAllInspectionsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const createPhoto = (createPhotoBody, options) => {
    const formData = new FormData();
    formData.append('documentable_id', createPhotoBody.documentable_id.toString());
    formData.append('documentable_type', createPhotoBody.documentable_type);
    formData.append('file', createPhotoBody.file);
    return axios.post(`/api/v1/photos`, formData, options);
};
export const getCreatePhotoMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createPhoto(data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useCreatePhoto = (options) => {
    const mutationOptions = getCreatePhotoMutationOptions(options);
    return useMutation(mutationOptions);
};
export const createInspection = (createInspectionBody, options) => {
    return axios.post(`/api/v1/inspectionWithAddress`, createInspectionBody, options);
};
export const getCreateInspectionMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createInspection(data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useCreateInspection = (options) => {
    const mutationOptions = getCreateInspectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const deleteOfficerAssessment = (officerAssessmentId, options) => {
    return axios.delete(`/api/v1/officer-assessments/${officerAssessmentId}`, options);
};
export const getDeleteOfficerAssessmentMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { officerAssessmentId } = props ?? {};
        return deleteOfficerAssessment(officerAssessmentId, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useDeleteOfficerAssessment = (options) => {
    const mutationOptions = getDeleteOfficerAssessmentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const updateOfficerAssessment = (officerAssessmentId, updateOfficerAssessmentBody, options) => {
    return axios.patch(`/api/v1/officer-assessments/${officerAssessmentId}`, updateOfficerAssessmentBody, options);
};
export const getUpdateOfficerAssessmentMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { officerAssessmentId, data } = props ?? {};
        return updateOfficerAssessment(officerAssessmentId, data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdateOfficerAssessment = (options) => {
    const mutationOptions = getUpdateOfficerAssessmentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const createOfficerAssessment = (createOfficerAssessmentBody, options) => {
    return axios.post(`/api/v1/officer-assessments`, createOfficerAssessmentBody, options);
};
export const getCreateOfficerAssessmentMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createOfficerAssessment(data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useCreateOfficerAssessment = (options) => {
    const mutationOptions = getCreateOfficerAssessmentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const updateFinding = (id, updateFindingBody, options) => {
    return axios.put(`/api/v1/findings/${id}`, updateFindingBody, options);
};
export const getUpdateFindingMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id, data } = props ?? {};
        return updateFinding(id, data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdateFinding = (options) => {
    const mutationOptions = getUpdateFindingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const deleteFinding = (id, options) => {
    return axios.delete(`/api/v1/findings/${id}`, options);
};
export const getDeleteFindingMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id } = props ?? {};
        return deleteFinding(id, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useDeleteFinding = (options) => {
    const mutationOptions = getDeleteFindingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const deleteOfficer = (id, options) => {
    return axios.delete(`/api/v1/officers/${id}`, options);
};
export const getDeleteOfficerMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id } = props ?? {};
        return deleteOfficer(id, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useDeleteOfficer = (options) => {
    const mutationOptions = getDeleteOfficerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const updateOfficer = (id, updateOfficerBody, options) => {
    return axios.put(`/api/v1/officers/${id}`, updateOfficerBody, options);
};
export const getUpdateOfficerMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id, data } = props ?? {};
        return updateOfficer(id, data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdateOfficer = (options) => {
    const mutationOptions = getUpdateOfficerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const checkUserPermissions = (id, params, options) => {
    return axios.get(`/api/v1/permissions/${id}/can`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getCheckUserPermissionsQueryKey = (id, params) => {
    return [`/api/v1/permissions/${id}/can`, ...(params ? [params] : [])];
};
export const getCheckUserPermissionsQueryOptions = (id, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getCheckUserPermissionsQueryKey(id, params);
    const queryFn = ({ signal }) => checkUserPermissions(id, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(id), ...queryOptions };
};
export function useCheckUserPermissions(id, params, options) {
    const queryOptions = getCheckUserPermissionsQueryOptions(id, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getCheckUserPermissionsSuspenseQueryOptions = (id, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getCheckUserPermissionsQueryKey(id, params);
    const queryFn = ({ signal }) => checkUserPermissions(id, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(id), ...queryOptions };
};
export function useCheckUserPermissionsSuspense(id, params, options) {
    const queryOptions = getCheckUserPermissionsSuspenseQueryOptions(id, params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const resendOfficerInvite = (id, options) => {
    return axios.post(`/api/v1/officer-invites/${id}/resend`, undefined, options);
};
export const getResendOfficerInviteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id } = props ?? {};
        return resendOfficerInvite(id, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useResendOfficerInvite = (options) => {
    const mutationOptions = getResendOfficerInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const deleteNote = (id, options) => {
    return axios.delete(`/api/v1/notes/${id}`, options);
};
export const getDeleteNoteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id } = props ?? {};
        return deleteNote(id, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useDeleteNote = (options) => {
    const mutationOptions = getDeleteNoteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const createNote = (createNoteBody, options) => {
    return axios.post(`/api/v1/notes`, createNoteBody, options);
};
export const getCreateNoteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createNote(data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useCreateNote = (options) => {
    const mutationOptions = getCreateNoteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getAllNotesByLocation = (locationId, options) => {
    return axios.get(`/api/v1/locations/${locationId}/notes`, options);
};
export const getGetAllNotesByLocationQueryKey = (locationId) => {
    return [`/api/v1/locations/${locationId}/notes`];
};
export const getGetAllNotesByLocationQueryOptions = (locationId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllNotesByLocationQueryKey(locationId);
    const queryFn = ({ signal }) => getAllNotesByLocation(locationId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(locationId), ...queryOptions };
};
export function useGetAllNotesByLocation(locationId, options) {
    const queryOptions = getGetAllNotesByLocationQueryOptions(locationId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllNotesByLocationSuspenseQueryOptions = (locationId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllNotesByLocationQueryKey(locationId);
    const queryFn = ({ signal }) => getAllNotesByLocation(locationId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(locationId), ...queryOptions };
};
export function useGetAllNotesByLocationSuspense(locationId, options) {
    const queryOptions = getGetAllNotesByLocationSuspenseQueryOptions(locationId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllNotesByOfficerAssessment = (officerAssessmentId, options) => {
    return axios.get(`/api/v1/officer-assessments/${officerAssessmentId}/notes`, options);
};
export const getGetAllNotesByOfficerAssessmentQueryKey = (officerAssessmentId) => {
    return [`/api/v1/officer-assessments/${officerAssessmentId}/notes`];
};
export const getGetAllNotesByOfficerAssessmentQueryOptions = (officerAssessmentId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllNotesByOfficerAssessmentQueryKey(officerAssessmentId);
    const queryFn = ({ signal }) => getAllNotesByOfficerAssessment(officerAssessmentId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(officerAssessmentId), ...queryOptions };
};
export function useGetAllNotesByOfficerAssessment(officerAssessmentId, options) {
    const queryOptions = getGetAllNotesByOfficerAssessmentQueryOptions(officerAssessmentId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllNotesByOfficerAssessmentSuspenseQueryOptions = (officerAssessmentId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllNotesByOfficerAssessmentQueryKey(officerAssessmentId);
    const queryFn = ({ signal }) => getAllNotesByOfficerAssessment(officerAssessmentId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(officerAssessmentId), ...queryOptions };
};
export function useGetAllNotesByOfficerAssessmentSuspense(officerAssessmentId, options) {
    const queryOptions = getGetAllNotesByOfficerAssessmentSuspenseQueryOptions(officerAssessmentId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllNotesByFinding = (findingId, options) => {
    return axios.get(`/api/v1/findings/${findingId}/notes`, options);
};
export const getGetAllNotesByFindingQueryKey = (findingId) => {
    return [`/api/v1/findings/${findingId}/notes`];
};
export const getGetAllNotesByFindingQueryOptions = (findingId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllNotesByFindingQueryKey(findingId);
    const queryFn = ({ signal }) => getAllNotesByFinding(findingId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(findingId), ...queryOptions };
};
export function useGetAllNotesByFinding(findingId, options) {
    const queryOptions = getGetAllNotesByFindingQueryOptions(findingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllNotesByFindingSuspenseQueryOptions = (findingId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllNotesByFindingQueryKey(findingId);
    const queryFn = ({ signal }) => getAllNotesByFinding(findingId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(findingId), ...queryOptions };
};
export function useGetAllNotesByFindingSuspense(findingId, options) {
    const queryOptions = getGetAllNotesByFindingSuspenseQueryOptions(findingId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const updateOfficerInvite = (id, updateOfficerInviteBody, options) => {
    return axios.put(`/api/v1/officer-invites/${id}`, updateOfficerInviteBody, options);
};
export const getUpdateOfficerInviteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id, data } = props ?? {};
        return updateOfficerInvite(id, data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdateOfficerInvite = (options) => {
    const mutationOptions = getUpdateOfficerInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const deleteOfficerInvite = (id, options) => {
    return axios.delete(`/api/v1/officer-invites/${id}`, options);
};
export const getDeleteOfficerInviteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id } = props ?? {};
        return deleteOfficerInvite(id, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useDeleteOfficerInvite = (options) => {
    const mutationOptions = getDeleteOfficerInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const inviteContactForRemoteSubmission = (inviteContactForRemoteSubmissionBody, options) => {
    return axios.post(`/api/v1/remote-submission-invites`, inviteContactForRemoteSubmissionBody, options);
};
export const getInviteContactForRemoteSubmissionMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return inviteContactForRemoteSubmission(data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useInviteContactForRemoteSubmission = (options) => {
    const mutationOptions = getInviteContactForRemoteSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const resendRemoteSubmissionInvite = (id, options) => {
    return axios.post(`/api/v1/remote-submission-invites/${id}/resend`, undefined, options);
};
export const getResendRemoteSubmissionInviteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id } = props ?? {};
        return resendRemoteSubmissionInvite(id, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useResendRemoteSubmissionInvite = (options) => {
    const mutationOptions = getResendRemoteSubmissionInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const deleteRemoteSubmissionInvite = (id, options) => {
    return axios.delete(`/api/v1/remote-submission-invites/${id}/delete`, options);
};
export const getDeleteRemoteSubmissionInviteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id } = props ?? {};
        return deleteRemoteSubmissionInvite(id, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useDeleteRemoteSubmissionInvite = (options) => {
    const mutationOptions = getDeleteRemoteSubmissionInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getAllOfficerInvites = (params, options) => {
    return axios.get(`/api/v1/officer-invites`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetAllOfficerInvitesQueryKey = (params) => {
    return [`/api/v1/officer-invites`, ...(params ? [params] : [])];
};
export const getGetAllOfficerInvitesQueryOptions = (params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllOfficerInvitesQueryKey(params);
    const queryFn = ({ signal }) => getAllOfficerInvites(params, { signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllOfficerInvites(params, options) {
    const queryOptions = getGetAllOfficerInvitesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllOfficerInvitesSuspenseQueryOptions = (params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllOfficerInvitesQueryKey(params);
    const queryFn = ({ signal }) => getAllOfficerInvites(params, { signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllOfficerInvitesSuspense(params, options) {
    const queryOptions = getGetAllOfficerInvitesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const createOfficerInvite = (createOfficerInviteBody, options) => {
    return axios.post(`/api/v1/officer-invites`, createOfficerInviteBody, options);
};
export const getCreateOfficerInviteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createOfficerInvite(data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useCreateOfficerInvite = (options) => {
    const mutationOptions = getCreateOfficerInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const deleteContact = (id, options) => {
    return axios.delete(`/api/v1/contacts/${id}`, options);
};
export const getDeleteContactMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id } = props ?? {};
        return deleteContact(id, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useDeleteContact = (options) => {
    const mutationOptions = getDeleteContactMutationOptions(options);
    return useMutation(mutationOptions);
};
export const updateContact = (id, updateContactBody, options) => {
    return axios.put(`/api/v1/contacts_full/${id}`, updateContactBody, options);
};
export const getUpdateContactMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id, data } = props ?? {};
        return updateContact(id, data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdateContact = (options) => {
    const mutationOptions = getUpdateContactMutationOptions(options);
    return useMutation(mutationOptions);
};
export const createContact = (createContactBody, options) => {
    return axios.post(`/api/v1/contacts_full`, createContactBody, options);
};
export const getCreateContactMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createContact(data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useCreateContact = (options) => {
    const mutationOptions = getCreateContactMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getAllOfficers = (params, options) => {
    return axios.get(`/api/v1/officers`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetAllOfficersQueryKey = (params) => {
    return [`/api/v1/officers`, ...(params ? [params] : [])];
};
export const getGetAllOfficersQueryOptions = (params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllOfficersQueryKey(params);
    const queryFn = ({ signal }) => getAllOfficers(params, { signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllOfficers(params, options) {
    const queryOptions = getGetAllOfficersQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllOfficersSuspenseQueryOptions = (params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllOfficersQueryKey(params);
    const queryFn = ({ signal }) => getAllOfficers(params, { signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllOfficersSuspense(params, options) {
    const queryOptions = getGetAllOfficersSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const updateOrganisation = (id, updateOrganisationBody, options) => {
    return axios.put(`/api/v1/service-providers/${id}`, updateOrganisationBody, options);
};
export const getUpdateOrganisationMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id, data } = props ?? {};
        return updateOrganisation(id, data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdateOrganisation = (options) => {
    const mutationOptions = getUpdateOrganisationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getOneOrganisation = (id, options) => {
    return axios.get(`/api/v1/service-providers/${id}`, options);
};
export const getGetOneOrganisationQueryKey = (id) => {
    return [`/api/v1/service-providers/${id}`];
};
export const getGetOneOrganisationQueryOptions = (id, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOneOrganisationQueryKey(id);
    const queryFn = ({ signal }) => getOneOrganisation(id, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(id), ...queryOptions };
};
export function useGetOneOrganisation(id, options) {
    const queryOptions = getGetOneOrganisationQueryOptions(id, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetOneOrganisationSuspenseQueryOptions = (id, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOneOrganisationQueryKey(id);
    const queryFn = ({ signal }) => getOneOrganisation(id, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(id), ...queryOptions };
};
export function useGetOneOrganisationSuspense(id, options) {
    const queryOptions = getGetOneOrganisationSuspenseQueryOptions(id, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getOneProperty = (id, options) => {
    return axios.get(`/api/v1/properties/${id}`, options);
};
export const getGetOnePropertyQueryKey = (id) => {
    return [`/api/v1/properties/${id}`];
};
export const getGetOnePropertyQueryOptions = (id, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOnePropertyQueryKey(id);
    const queryFn = ({ signal }) => getOneProperty(id, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(id), ...queryOptions };
};
export function useGetOneProperty(id, options) {
    const queryOptions = getGetOnePropertyQueryOptions(id, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetOnePropertySuspenseQueryOptions = (id, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOnePropertyQueryKey(id);
    const queryFn = ({ signal }) => getOneProperty(id, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(id), ...queryOptions };
};
export function useGetOnePropertySuspense(id, options) {
    const queryOptions = getGetOnePropertySuspenseQueryOptions(id, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getOneOfficerAssessment = (id, options) => {
    return axios.get(`/api/v1/officer-assessments/${id}`, options);
};
export const getGetOneOfficerAssessmentQueryKey = (id) => {
    return [`/api/v1/officer-assessments/${id}`];
};
export const getGetOneOfficerAssessmentQueryOptions = (id, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOneOfficerAssessmentQueryKey(id);
    const queryFn = ({ signal }) => getOneOfficerAssessment(id, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(id), ...queryOptions };
};
export function useGetOneOfficerAssessment(id, options) {
    const queryOptions = getGetOneOfficerAssessmentQueryOptions(id, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetOneOfficerAssessmentSuspenseQueryOptions = (id, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOneOfficerAssessmentQueryKey(id);
    const queryFn = ({ signal }) => getOneOfficerAssessment(id, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(id), ...queryOptions };
};
export function useGetOneOfficerAssessmentSuspense(id, options) {
    const queryOptions = getGetOneOfficerAssessmentSuspenseQueryOptions(id, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllRoomPositions = (options) => {
    return axios.get(`/api/v1/room-positions`, options);
};
export const getGetAllRoomPositionsQueryKey = () => {
    return [`/api/v1/room-positions`];
};
export const getGetAllRoomPositionsQueryOptions = (options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllRoomPositionsQueryKey();
    const queryFn = ({ signal }) => getAllRoomPositions({ signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllRoomPositions(options) {
    const queryOptions = getGetAllRoomPositionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllRoomPositionsSuspenseQueryOptions = (options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllRoomPositionsQueryKey();
    const queryFn = ({ signal }) => getAllRoomPositions({ signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllRoomPositionsSuspense(options) {
    const queryOptions = getGetAllRoomPositionsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllInspectionStatuses = (options) => {
    return axios.get(`/api/v1/statuses`, options);
};
export const getGetAllInspectionStatusesQueryKey = () => {
    return [`/api/v1/statuses`];
};
export const getGetAllInspectionStatusesQueryOptions = (options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllInspectionStatusesQueryKey();
    const queryFn = ({ signal }) => getAllInspectionStatuses({ signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllInspectionStatuses(options) {
    const queryOptions = getGetAllInspectionStatusesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllInspectionStatusesSuspenseQueryOptions = (options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllInspectionStatusesQueryKey();
    const queryFn = ({ signal }) => getAllInspectionStatuses({ signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllInspectionStatusesSuspense(options) {
    const queryOptions = getGetAllInspectionStatusesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllHazards = (options) => {
    return axios.get(`/api/v1/hazards`, options);
};
export const getGetAllHazardsQueryKey = () => {
    return [`/api/v1/hazards`];
};
export const getGetAllHazardsQueryOptions = (options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllHazardsQueryKey();
    const queryFn = ({ signal }) => getAllHazards({ signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllHazards(options) {
    const queryOptions = getGetAllHazardsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllHazardsSuspenseQueryOptions = (options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllHazardsQueryKey();
    const queryFn = ({ signal }) => getAllHazards({ signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllHazardsSuspense(options) {
    const queryOptions = getGetAllHazardsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllActionTypes = (options) => {
    return axios.get(`/api/v1/action-types`, options);
};
export const getGetAllActionTypesQueryKey = () => {
    return [`/api/v1/action-types`];
};
export const getGetAllActionTypesQueryOptions = (options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllActionTypesQueryKey();
    const queryFn = ({ signal }) => getAllActionTypes({ signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllActionTypes(options) {
    const queryOptions = getGetAllActionTypesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllActionTypesSuspenseQueryOptions = (options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllActionTypesQueryKey();
    const queryFn = ({ signal }) => getAllActionTypes({ signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllActionTypesSuspense(options) {
    const queryOptions = getGetAllActionTypesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllElementTypes = (options) => {
    return axios.get(`/api/v1/element-types`, options);
};
export const getGetAllElementTypesQueryKey = () => {
    return [`/api/v1/element-types`];
};
export const getGetAllElementTypesQueryOptions = (options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllElementTypesQueryKey();
    const queryFn = ({ signal }) => getAllElementTypes({ signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllElementTypes(options) {
    const queryOptions = getGetAllElementTypesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllElementTypesSuspenseQueryOptions = (options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllElementTypesQueryKey();
    const queryFn = ({ signal }) => getAllElementTypes({ signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllElementTypesSuspense(options) {
    const queryOptions = getGetAllElementTypesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllAiFeedbackReasons = (options) => {
    return axios.get(`/api/v1/ai-feedback-reasons`, options);
};
export const getGetAllAiFeedbackReasonsQueryKey = () => {
    return [`/api/v1/ai-feedback-reasons`];
};
export const getGetAllAiFeedbackReasonsQueryOptions = (options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllAiFeedbackReasonsQueryKey();
    const queryFn = ({ signal }) => getAllAiFeedbackReasons({ signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllAiFeedbackReasons(options) {
    const queryOptions = getGetAllAiFeedbackReasonsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllAiFeedbackReasonsSuspenseQueryOptions = (options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllAiFeedbackReasonsQueryKey();
    const queryFn = ({ signal }) => getAllAiFeedbackReasons({ signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllAiFeedbackReasonsSuspense(options) {
    const queryOptions = getGetAllAiFeedbackReasonsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllOccupantAgeRanges = (params, options) => {
    return axios.get(`/api/v1/occupant-age-ranges`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetAllOccupantAgeRangesQueryKey = (params) => {
    return [`/api/v1/occupant-age-ranges`, ...(params ? [params] : [])];
};
export const getGetAllOccupantAgeRangesQueryOptions = (params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllOccupantAgeRangesQueryKey(params);
    const queryFn = ({ signal }) => getAllOccupantAgeRanges(params, { signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllOccupantAgeRanges(params, options) {
    const queryOptions = getGetAllOccupantAgeRangesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllOccupantAgeRangesSuspenseQueryOptions = (params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllOccupantAgeRangesQueryKey(params);
    const queryFn = ({ signal }) => getAllOccupantAgeRanges(params, { signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllOccupantAgeRangesSuspense(params, options) {
    const queryOptions = getGetAllOccupantAgeRangesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllTenancyTypes = (params, options) => {
    return axios.get(`/api/v1/tenancy-types`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetAllTenancyTypesQueryKey = (params) => {
    return [`/api/v1/tenancy-types`, ...(params ? [params] : [])];
};
export const getGetAllTenancyTypesQueryOptions = (params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllTenancyTypesQueryKey(params);
    const queryFn = ({ signal }) => getAllTenancyTypes(params, { signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllTenancyTypes(params, options) {
    const queryOptions = getGetAllTenancyTypesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllTenancyTypesSuspenseQueryOptions = (params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllTenancyTypesQueryKey(params);
    const queryFn = ({ signal }) => getAllTenancyTypes(params, { signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAllTenancyTypesSuspense(params, options) {
    const queryOptions = getGetAllTenancyTypesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const markRemoteSubmissionLocationAsRead = (id, options) => {
    return axios.post(`/api/v1/remote-submission-locations/${id}/read`, undefined, options);
};
export const getMarkRemoteSubmissionLocationAsReadMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id } = props ?? {};
        return markRemoteSubmissionLocationAsRead(id, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useMarkRemoteSubmissionLocationAsRead = (options) => {
    const mutationOptions = getMarkRemoteSubmissionLocationAsReadMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getAiFeedback = (params, options) => {
    return axios.get(`/api/v1/ai-feedback`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetAiFeedbackQueryKey = (params) => {
    return [`/api/v1/ai-feedback`, ...(params ? [params] : [])];
};
export const getGetAiFeedbackQueryOptions = (params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAiFeedbackQueryKey(params);
    const queryFn = ({ signal }) => getAiFeedback(params, { signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAiFeedback(params, options) {
    const queryOptions = getGetAiFeedbackQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAiFeedbackSuspenseQueryOptions = (params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAiFeedbackQueryKey(params);
    const queryFn = ({ signal }) => getAiFeedback(params, { signal, ...axiosOptions });
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetAiFeedbackSuspense(params, options) {
    const queryOptions = getGetAiFeedbackSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const submitAiFeedback = (submitAiFeedbackBody, options) => {
    return axios.put(`/api/v1/ai-feedback`, submitAiFeedbackBody, options);
};
export const getSubmitAiFeedbackMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return submitAiFeedback(data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useSubmitAiFeedback = (options) => {
    const mutationOptions = getSubmitAiFeedbackMutationOptions(options);
    return useMutation(mutationOptions);
};
export const createHousehold = (createHouseholdBody, options) => {
    return axios.post(`/api/v1/households`, createHouseholdBody, options);
};
export const getCreateHouseholdMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createHousehold(data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useCreateHousehold = (options) => {
    const mutationOptions = getCreateHouseholdMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getScoringValidationStatus = (inspectionId, options) => {
    return axios.get(`/api/v1/inspections/${inspectionId}/validate`, options);
};
export const getGetScoringValidationStatusQueryKey = (inspectionId) => {
    return [`/api/v1/inspections/${inspectionId}/validate`];
};
export const getGetScoringValidationStatusQueryOptions = (inspectionId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetScoringValidationStatusQueryKey(inspectionId);
    const queryFn = ({ signal }) => getScoringValidationStatus(inspectionId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetScoringValidationStatus(inspectionId, options) {
    const queryOptions = getGetScoringValidationStatusQueryOptions(inspectionId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetScoringValidationStatusSuspenseQueryOptions = (inspectionId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetScoringValidationStatusQueryKey(inspectionId);
    const queryFn = ({ signal }) => getScoringValidationStatus(inspectionId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetScoringValidationStatusSuspense(inspectionId, options) {
    const queryOptions = getGetScoringValidationStatusSuspenseQueryOptions(inspectionId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getInspectionScoring = (inspectionId, params, options) => {
    return axios.get(`/api/v1/inspections/${inspectionId}/scoring`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetInspectionScoringQueryKey = (inspectionId, params) => {
    return [`/api/v1/inspections/${inspectionId}/scoring`, ...(params ? [params] : [])];
};
export const getGetInspectionScoringQueryOptions = (inspectionId, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionScoringQueryKey(inspectionId, params);
    const queryFn = ({ signal }) => getInspectionScoring(inspectionId, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionScoring(inspectionId, params, options) {
    const queryOptions = getGetInspectionScoringQueryOptions(inspectionId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetInspectionScoringSuspenseQueryOptions = (inspectionId, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionScoringQueryKey(inspectionId, params);
    const queryFn = ({ signal }) => getInspectionScoring(inspectionId, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionScoringSuspense(inspectionId, params, options) {
    const queryOptions = getGetInspectionScoringSuspenseQueryOptions(inspectionId, params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getPhotoBySizeForRemoteSubmission = (token, id, size, options) => {
    return axios.get(`/api/v1/remote-submissions/${token}/photos/${id}/${size}`, options);
};
export const getGetPhotoBySizeForRemoteSubmissionQueryKey = (token, id, size) => {
    return [`/api/v1/remote-submissions/${token}/photos/${id}/${size}`];
};
export const getGetPhotoBySizeForRemoteSubmissionQueryOptions = (token, id, size, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPhotoBySizeForRemoteSubmissionQueryKey(token, id, size);
    const queryFn = ({ signal }) => getPhotoBySizeForRemoteSubmission(token, id, size, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && id && size), ...queryOptions };
};
export function useGetPhotoBySizeForRemoteSubmission(token, id, size, options) {
    const queryOptions = getGetPhotoBySizeForRemoteSubmissionQueryOptions(token, id, size, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetPhotoBySizeForRemoteSubmissionSuspenseQueryOptions = (token, id, size, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPhotoBySizeForRemoteSubmissionQueryKey(token, id, size);
    const queryFn = ({ signal }) => getPhotoBySizeForRemoteSubmission(token, id, size, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && id && size), ...queryOptions };
};
export function useGetPhotoBySizeForRemoteSubmissionSuspense(token, id, size, options) {
    const queryOptions = getGetPhotoBySizeForRemoteSubmissionSuspenseQueryOptions(token, id, size, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getPhotoBySizeForShare = (id, size, token, options) => {
    return axios.get(`/api/v1/photos/${id}/${size}/token/${token}`, options);
};
export const getGetPhotoBySizeForShareQueryKey = (id, size, token) => {
    return [`/api/v1/photos/${id}/${size}/token/${token}`];
};
export const getGetPhotoBySizeForShareQueryOptions = (id, size, token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPhotoBySizeForShareQueryKey(id, size, token);
    const queryFn = ({ signal }) => getPhotoBySizeForShare(id, size, token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(id && size && token), ...queryOptions };
};
export function useGetPhotoBySizeForShare(id, size, token, options) {
    const queryOptions = getGetPhotoBySizeForShareQueryOptions(id, size, token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetPhotoBySizeForShareSuspenseQueryOptions = (id, size, token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPhotoBySizeForShareQueryKey(id, size, token);
    const queryFn = ({ signal }) => getPhotoBySizeForShare(id, size, token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(id && size && token), ...queryOptions };
};
export function useGetPhotoBySizeForShareSuspense(id, size, token, options) {
    const queryOptions = getGetPhotoBySizeForShareSuspenseQueryOptions(id, size, token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getFindingPhotosBySizeAndLocationForShare = (token, locationId, size, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/locations/${locationId}/finding-photos/${size}`, options);
};
export const getGetFindingPhotosBySizeAndLocationForShareQueryKey = (token, locationId, size) => {
    return [`/api/v1/inspection-share/${token}/locations/${locationId}/finding-photos/${size}`];
};
export const getGetFindingPhotosBySizeAndLocationForShareQueryOptions = (token, locationId, size, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFindingPhotosBySizeAndLocationForShareQueryKey(token, locationId, size);
    const queryFn = ({ signal }) => getFindingPhotosBySizeAndLocationForShare(token, locationId, size, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && locationId && size), ...queryOptions };
};
export function useGetFindingPhotosBySizeAndLocationForShare(token, locationId, size, options) {
    const queryOptions = getGetFindingPhotosBySizeAndLocationForShareQueryOptions(token, locationId, size, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetFindingPhotosBySizeAndLocationForShareSuspenseQueryOptions = (token, locationId, size, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFindingPhotosBySizeAndLocationForShareQueryKey(token, locationId, size);
    const queryFn = ({ signal }) => getFindingPhotosBySizeAndLocationForShare(token, locationId, size, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && locationId && size), ...queryOptions };
};
export function useGetFindingPhotosBySizeAndLocationForShareSuspense(token, locationId, size, options) {
    const queryOptions = getGetFindingPhotosBySizeAndLocationForShareSuspenseQueryOptions(token, locationId, size, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getFindingPhotosBySizeAndHazardForShare = (token, hazardId, size, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/hazards/${hazardId}/finding-photos/${size}`, options);
};
export const getGetFindingPhotosBySizeAndHazardForShareQueryKey = (token, hazardId, size) => {
    return [`/api/v1/inspection-share/${token}/hazards/${hazardId}/finding-photos/${size}`];
};
export const getGetFindingPhotosBySizeAndHazardForShareQueryOptions = (token, hazardId, size, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFindingPhotosBySizeAndHazardForShareQueryKey(token, hazardId, size);
    const queryFn = ({ signal }) => getFindingPhotosBySizeAndHazardForShare(token, hazardId, size, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && hazardId && size), ...queryOptions };
};
export function useGetFindingPhotosBySizeAndHazardForShare(token, hazardId, size, options) {
    const queryOptions = getGetFindingPhotosBySizeAndHazardForShareQueryOptions(token, hazardId, size, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetFindingPhotosBySizeAndHazardForShareSuspenseQueryOptions = (token, hazardId, size, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFindingPhotosBySizeAndHazardForShareQueryKey(token, hazardId, size);
    const queryFn = ({ signal }) => getFindingPhotosBySizeAndHazardForShare(token, hazardId, size, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && hazardId && size), ...queryOptions };
};
export function useGetFindingPhotosBySizeAndHazardForShareSuspense(token, hazardId, size, options) {
    const queryOptions = getGetFindingPhotosBySizeAndHazardForShareSuspenseQueryOptions(token, hazardId, size, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllNotesByLocationForShare = (token, locationId, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/locations/${locationId}/notes`, options);
};
export const getGetAllNotesByLocationForShareQueryKey = (token, locationId) => {
    return [`/api/v1/inspection-share/${token}/locations/${locationId}/notes`];
};
export const getGetAllNotesByLocationForShareQueryOptions = (token, locationId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllNotesByLocationForShareQueryKey(token, locationId);
    const queryFn = ({ signal }) => getAllNotesByLocationForShare(token, locationId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && locationId), ...queryOptions };
};
export function useGetAllNotesByLocationForShare(token, locationId, options) {
    const queryOptions = getGetAllNotesByLocationForShareQueryOptions(token, locationId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllNotesByLocationForShareSuspenseQueryOptions = (token, locationId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllNotesByLocationForShareQueryKey(token, locationId);
    const queryFn = ({ signal }) => getAllNotesByLocationForShare(token, locationId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && locationId), ...queryOptions };
};
export function useGetAllNotesByLocationForShareSuspense(token, locationId, options) {
    const queryOptions = getGetAllNotesByLocationForShareSuspenseQueryOptions(token, locationId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllNotesByFindingForShare = (token, findingId, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/findings/${findingId}/notes`, options);
};
export const getGetAllNotesByFindingForShareQueryKey = (token, findingId) => {
    return [`/api/v1/inspection-share/${token}/findings/${findingId}/notes`];
};
export const getGetAllNotesByFindingForShareQueryOptions = (token, findingId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllNotesByFindingForShareQueryKey(token, findingId);
    const queryFn = ({ signal }) => getAllNotesByFindingForShare(token, findingId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && findingId), ...queryOptions };
};
export function useGetAllNotesByFindingForShare(token, findingId, options) {
    const queryOptions = getGetAllNotesByFindingForShareQueryOptions(token, findingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllNotesByFindingForShareSuspenseQueryOptions = (token, findingId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllNotesByFindingForShareQueryKey(token, findingId);
    const queryFn = ({ signal }) => getAllNotesByFindingForShare(token, findingId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && findingId), ...queryOptions };
};
export function useGetAllNotesByFindingForShareSuspense(token, findingId, options) {
    const queryOptions = getGetAllNotesByFindingForShareSuspenseQueryOptions(token, findingId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getScoringValidationStatusForShare = (token, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/validate`, options);
};
export const getGetScoringValidationStatusForShareQueryKey = (token) => {
    return [`/api/v1/inspection-share/${token}/validate`];
};
export const getGetScoringValidationStatusForShareQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetScoringValidationStatusForShareQueryKey(token);
    const queryFn = ({ signal }) => getScoringValidationStatusForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetScoringValidationStatusForShare(token, options) {
    const queryOptions = getGetScoringValidationStatusForShareQueryOptions(token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetScoringValidationStatusForShareSuspenseQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetScoringValidationStatusForShareQueryKey(token);
    const queryFn = ({ signal }) => getScoringValidationStatusForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetScoringValidationStatusForShareSuspense(token, options) {
    const queryOptions = getGetScoringValidationStatusForShareSuspenseQueryOptions(token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getNationalAveragesForHazardForShare = (token, hazardId, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/scoring/national-averages/${hazardId}`, options);
};
export const getGetNationalAveragesForHazardForShareQueryKey = (token, hazardId) => {
    return [`/api/v1/inspection-share/${token}/scoring/national-averages/${hazardId}`];
};
export const getGetNationalAveragesForHazardForShareQueryOptions = (token, hazardId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetNationalAveragesForHazardForShareQueryKey(token, hazardId);
    const queryFn = ({ signal }) => getNationalAveragesForHazardForShare(token, hazardId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && hazardId), ...queryOptions };
};
export function useGetNationalAveragesForHazardForShare(token, hazardId, options) {
    const queryOptions = getGetNationalAveragesForHazardForShareQueryOptions(token, hazardId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetNationalAveragesForHazardForShareSuspenseQueryOptions = (token, hazardId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetNationalAveragesForHazardForShareQueryKey(token, hazardId);
    const queryFn = ({ signal }) => getNationalAveragesForHazardForShare(token, hazardId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && hazardId), ...queryOptions };
};
export function useGetNationalAveragesForHazardForShareSuspense(token, hazardId, options) {
    const queryOptions = getGetNationalAveragesForHazardForShareSuspenseQueryOptions(token, hazardId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllHazardsForShare = (token, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/hazards`, options);
};
export const getGetAllHazardsForShareQueryKey = (token) => {
    return [`/api/v1/inspection-share/${token}/hazards`];
};
export const getGetAllHazardsForShareQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllHazardsForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllHazardsForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllHazardsForShare(token, options) {
    const queryOptions = getGetAllHazardsForShareQueryOptions(token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllHazardsForShareSuspenseQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllHazardsForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllHazardsForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllHazardsForShareSuspense(token, options) {
    const queryOptions = getGetAllHazardsForShareSuspenseQueryOptions(token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllHouseholdsForShare = (token, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/households`, options);
};
export const getGetAllHouseholdsForShareQueryKey = (token) => {
    return [`/api/v1/inspection-share/${token}/households`];
};
export const getGetAllHouseholdsForShareQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllHouseholdsForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllHouseholdsForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllHouseholdsForShare(token, options) {
    const queryOptions = getGetAllHouseholdsForShareQueryOptions(token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllHouseholdsForShareSuspenseQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllHouseholdsForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllHouseholdsForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllHouseholdsForShareSuspense(token, options) {
    const queryOptions = getGetAllHouseholdsForShareSuspenseQueryOptions(token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllTenancyTypesForShare = (token, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/tenancy-types`, options);
};
export const getGetAllTenancyTypesForShareQueryKey = (token) => {
    return [`/api/v1/inspection-share/${token}/tenancy-types`];
};
export const getGetAllTenancyTypesForShareQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllTenancyTypesForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllTenancyTypesForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllTenancyTypesForShare(token, options) {
    const queryOptions = getGetAllTenancyTypesForShareQueryOptions(token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllTenancyTypesForShareSuspenseQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllTenancyTypesForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllTenancyTypesForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllTenancyTypesForShareSuspense(token, options) {
    const queryOptions = getGetAllTenancyTypesForShareSuspenseQueryOptions(token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllOccupantAgeRangesForShare = (token, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/occupant-age-ranges`, options);
};
export const getGetAllOccupantAgeRangesForShareQueryKey = (token) => {
    return [`/api/v1/inspection-share/${token}/occupant-age-ranges`];
};
export const getGetAllOccupantAgeRangesForShareQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllOccupantAgeRangesForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllOccupantAgeRangesForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllOccupantAgeRangesForShare(token, options) {
    const queryOptions = getGetAllOccupantAgeRangesForShareQueryOptions(token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllOccupantAgeRangesForShareSuspenseQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllOccupantAgeRangesForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllOccupantAgeRangesForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllOccupantAgeRangesForShareSuspense(token, options) {
    const queryOptions = getGetAllOccupantAgeRangesForShareSuspenseQueryOptions(token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllActionTypesForShare = (token, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/action-types`, options);
};
export const getGetAllActionTypesForShareQueryKey = (token) => {
    return [`/api/v1/inspection-share/${token}/action-types`];
};
export const getGetAllActionTypesForShareQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllActionTypesForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllActionTypesForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllActionTypesForShare(token, options) {
    const queryOptions = getGetAllActionTypesForShareQueryOptions(token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllActionTypesForShareSuspenseQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllActionTypesForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllActionTypesForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllActionTypesForShareSuspense(token, options) {
    const queryOptions = getGetAllActionTypesForShareSuspenseQueryOptions(token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getRemoteSubmissionInviteByToken = (token, options) => {
    return axios.get(`/api/v1/remote-submission-invites/${token}`, options);
};
export const getGetRemoteSubmissionInviteByTokenQueryKey = (token) => {
    return [`/api/v1/remote-submission-invites/${token}`];
};
export const getGetRemoteSubmissionInviteByTokenQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRemoteSubmissionInviteByTokenQueryKey(token);
    const queryFn = ({ signal }) => getRemoteSubmissionInviteByToken(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetRemoteSubmissionInviteByToken(token, options) {
    const queryOptions = getGetRemoteSubmissionInviteByTokenQueryOptions(token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetRemoteSubmissionInviteByTokenSuspenseQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRemoteSubmissionInviteByTokenQueryKey(token);
    const queryFn = ({ signal }) => getRemoteSubmissionInviteByToken(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetRemoteSubmissionInviteByTokenSuspense(token, options) {
    const queryOptions = getGetRemoteSubmissionInviteByTokenSuspenseQueryOptions(token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllLocationTypesForRemoteSubmission = (token, options) => {
    return axios.get(`/api/v1/remote-submissions/${token}/location-types`, options);
};
export const getGetAllLocationTypesForRemoteSubmissionQueryKey = (token) => {
    return [`/api/v1/remote-submissions/${token}/location-types`];
};
export const getGetAllLocationTypesForRemoteSubmissionQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllLocationTypesForRemoteSubmissionQueryKey(token);
    const queryFn = ({ signal }) => getAllLocationTypesForRemoteSubmission(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllLocationTypesForRemoteSubmission(token, options) {
    const queryOptions = getGetAllLocationTypesForRemoteSubmissionQueryOptions(token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllLocationTypesForRemoteSubmissionSuspenseQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllLocationTypesForRemoteSubmissionQueryKey(token);
    const queryFn = ({ signal }) => getAllLocationTypesForRemoteSubmission(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllLocationTypesForRemoteSubmissionSuspense(token, options) {
    const queryOptions = getGetAllLocationTypesForRemoteSubmissionSuspenseQueryOptions(token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllElementsForRemoteSubmission = (token, options) => {
    return axios.get(`/api/v1/remote-submissions/${token}/element-types`, options);
};
export const getGetAllElementsForRemoteSubmissionQueryKey = (token) => {
    return [`/api/v1/remote-submissions/${token}/element-types`];
};
export const getGetAllElementsForRemoteSubmissionQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllElementsForRemoteSubmissionQueryKey(token);
    const queryFn = ({ signal }) => getAllElementsForRemoteSubmission(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllElementsForRemoteSubmission(token, options) {
    const queryOptions = getGetAllElementsForRemoteSubmissionQueryOptions(token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllElementsForRemoteSubmissionSuspenseQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllElementsForRemoteSubmissionQueryKey(token);
    const queryFn = ({ signal }) => getAllElementsForRemoteSubmission(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllElementsForRemoteSubmissionSuspense(token, options) {
    const queryOptions = getGetAllElementsForRemoteSubmissionSuspenseQueryOptions(token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllElementTypesForShare = (token, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/element-types`, options);
};
export const getGetAllElementTypesForShareQueryKey = (token) => {
    return [`/api/v1/inspection-share/${token}/element-types`];
};
export const getGetAllElementTypesForShareQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllElementTypesForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllElementTypesForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllElementTypesForShare(token, options) {
    const queryOptions = getGetAllElementTypesForShareQueryOptions(token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllElementTypesForShareSuspenseQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllElementTypesForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllElementTypesForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllElementTypesForShareSuspense(token, options) {
    const queryOptions = getGetAllElementTypesForShareSuspenseQueryOptions(token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getLocationFindingsForShare = (token, locationId, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/locations/${locationId}/findings`, options);
};
export const getGetLocationFindingsForShareQueryKey = (token, locationId) => {
    return [`/api/v1/inspection-share/${token}/locations/${locationId}/findings`];
};
export const getGetLocationFindingsForShareQueryOptions = (token, locationId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLocationFindingsForShareQueryKey(token, locationId);
    const queryFn = ({ signal }) => getLocationFindingsForShare(token, locationId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && locationId), ...queryOptions };
};
export function useGetLocationFindingsForShare(token, locationId, options) {
    const queryOptions = getGetLocationFindingsForShareQueryOptions(token, locationId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetLocationFindingsForShareSuspenseQueryOptions = (token, locationId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLocationFindingsForShareQueryKey(token, locationId);
    const queryFn = ({ signal }) => getLocationFindingsForShare(token, locationId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && locationId), ...queryOptions };
};
export function useGetLocationFindingsForShareSuspense(token, locationId, options) {
    const queryOptions = getGetLocationFindingsForShareSuspenseQueryOptions(token, locationId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getHazardFindingsForShare = (token, hazardId, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/hazards/${hazardId}/findings`, options);
};
export const getGetHazardFindingsForShareQueryKey = (token, hazardId) => {
    return [`/api/v1/inspection-share/${token}/hazards/${hazardId}/findings`];
};
export const getGetHazardFindingsForShareQueryOptions = (token, hazardId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetHazardFindingsForShareQueryKey(token, hazardId);
    const queryFn = ({ signal }) => getHazardFindingsForShare(token, hazardId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && hazardId), ...queryOptions };
};
export function useGetHazardFindingsForShare(token, hazardId, options) {
    const queryOptions = getGetHazardFindingsForShareQueryOptions(token, hazardId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetHazardFindingsForShareSuspenseQueryOptions = (token, hazardId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetHazardFindingsForShareQueryKey(token, hazardId);
    const queryFn = ({ signal }) => getHazardFindingsForShare(token, hazardId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token && hazardId), ...queryOptions };
};
export function useGetHazardFindingsForShareSuspense(token, hazardId, options) {
    const queryOptions = getGetHazardFindingsForShareSuspenseQueryOptions(token, hazardId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllRoomPositionsForShare = (token, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/room-positions`, options);
};
export const getGetAllRoomPositionsForShareQueryKey = (token) => {
    return [`/api/v1/inspection-share/${token}/room-positions`];
};
export const getGetAllRoomPositionsForShareQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllRoomPositionsForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllRoomPositionsForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllRoomPositionsForShare(token, options) {
    const queryOptions = getGetAllRoomPositionsForShareQueryOptions(token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllRoomPositionsForShareSuspenseQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllRoomPositionsForShareQueryKey(token);
    const queryFn = ({ signal }) => getAllRoomPositionsForShare(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllRoomPositionsForShareSuspense(token, options) {
    const queryOptions = getGetAllRoomPositionsForShareSuspenseQueryOptions(token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllContactsByShareToken = (token, params, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/contacts`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetAllContactsByShareTokenQueryKey = (token, params) => {
    return [`/api/v1/inspection-share/${token}/contacts`, ...(params ? [params] : [])];
};
export const getGetAllContactsByShareTokenQueryOptions = (token, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllContactsByShareTokenQueryKey(token, params);
    const queryFn = ({ signal }) => getAllContactsByShareToken(token, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllContactsByShareToken(token, params, options) {
    const queryOptions = getGetAllContactsByShareTokenQueryOptions(token, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllContactsByShareTokenSuspenseQueryOptions = (token, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllContactsByShareTokenQueryKey(token, params);
    const queryFn = ({ signal }) => getAllContactsByShareToken(token, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllContactsByShareTokenSuspense(token, params, options) {
    const queryOptions = getGetAllContactsByShareTokenSuspenseQueryOptions(token, params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getInspectionScoringForShare = (token, params, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/scoring`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetInspectionScoringForShareQueryKey = (token, params) => {
    return [`/api/v1/inspection-share/${token}/scoring`, ...(params ? [params] : [])];
};
export const getGetInspectionScoringForShareQueryOptions = (token, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionScoringForShareQueryKey(token, params);
    const queryFn = ({ signal }) => getInspectionScoringForShare(token, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetInspectionScoringForShare(token, params, options) {
    const queryOptions = getGetInspectionScoringForShareQueryOptions(token, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetInspectionScoringForShareSuspenseQueryOptions = (token, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionScoringForShareQueryKey(token, params);
    const queryFn = ({ signal }) => getInspectionScoringForShare(token, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetInspectionScoringForShareSuspense(token, params, options) {
    const queryOptions = getGetInspectionScoringForShareSuspenseQueryOptions(token, params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getInspectionLocationsByShareToken = (token, params, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/locations`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetInspectionLocationsByShareTokenQueryKey = (token, params) => {
    return [`/api/v1/inspection-share/${token}/locations`, ...(params ? [params] : [])];
};
export const getGetInspectionLocationsByShareTokenQueryOptions = (token, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionLocationsByShareTokenQueryKey(token, params);
    const queryFn = ({ signal }) => getInspectionLocationsByShareToken(token, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetInspectionLocationsByShareToken(token, params, options) {
    const queryOptions = getGetInspectionLocationsByShareTokenQueryOptions(token, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetInspectionLocationsByShareTokenSuspenseQueryOptions = (token, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionLocationsByShareTokenQueryKey(token, params);
    const queryFn = ({ signal }) => getInspectionLocationsByShareToken(token, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetInspectionLocationsByShareTokenSuspense(token, params, options) {
    const queryOptions = getGetInspectionLocationsByShareTokenSuspenseQueryOptions(token, params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getInspectionHouseholds = (inspectionId, options) => {
    return axios.get(`/api/v1/inspections/${inspectionId}/households`, options);
};
export const getGetInspectionHouseholdsQueryKey = (inspectionId) => {
    return [`/api/v1/inspections/${inspectionId}/households`];
};
export const getGetInspectionHouseholdsQueryOptions = (inspectionId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionHouseholdsQueryKey(inspectionId);
    const queryFn = ({ signal }) => getInspectionHouseholds(inspectionId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionHouseholds(inspectionId, options) {
    const queryOptions = getGetInspectionHouseholdsQueryOptions(inspectionId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetInspectionHouseholdsSuspenseQueryOptions = (inspectionId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionHouseholdsQueryKey(inspectionId);
    const queryFn = ({ signal }) => getInspectionHouseholds(inspectionId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionHouseholdsSuspense(inspectionId, options) {
    const queryOptions = getGetInspectionHouseholdsSuspenseQueryOptions(inspectionId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getInspectionLocations = (inspectionId, params, options) => {
    return axios.get(`/api/v1/inspections/${inspectionId}/locations`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetInspectionLocationsQueryKey = (inspectionId, params) => {
    return [`/api/v1/inspections/${inspectionId}/locations`, ...(params ? [params] : [])];
};
export const getGetInspectionLocationsQueryOptions = (inspectionId, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionLocationsQueryKey(inspectionId, params);
    const queryFn = ({ signal }) => getInspectionLocations(inspectionId, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionLocations(inspectionId, params, options) {
    const queryOptions = getGetInspectionLocationsQueryOptions(inspectionId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetInspectionLocationsSuspenseQueryOptions = (inspectionId, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionLocationsQueryKey(inspectionId, params);
    const queryFn = ({ signal }) => getInspectionLocations(inspectionId, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionLocationsSuspense(inspectionId, params, options) {
    const queryOptions = getGetInspectionLocationsSuspenseQueryOptions(inspectionId, params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getInspectionExport = (inspectionId, options) => {
    return axios.get(`/api/v1/inspections/${inspectionId}/export`, {
        responseType: 'blob',
        ...options,
    });
};
export const getGetInspectionExportQueryKey = (inspectionId) => {
    return [`/api/v1/inspections/${inspectionId}/export`];
};
export const getGetInspectionExportQueryOptions = (inspectionId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionExportQueryKey(inspectionId);
    const queryFn = ({ signal }) => getInspectionExport(inspectionId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionExport(inspectionId, options) {
    const queryOptions = getGetInspectionExportQueryOptions(inspectionId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetInspectionExportSuspenseQueryOptions = (inspectionId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionExportQueryKey(inspectionId);
    const queryFn = ({ signal }) => getInspectionExport(inspectionId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionExportSuspense(inspectionId, options) {
    const queryOptions = getGetInspectionExportSuspenseQueryOptions(inspectionId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getInspectionDetail = (inspectionId, options) => {
    return axios.get(`/api/v1/inspections/${inspectionId}`, options);
};
export const getGetInspectionDetailQueryKey = (inspectionId) => {
    return [`/api/v1/inspections/${inspectionId}`];
};
export const getGetInspectionDetailQueryOptions = (inspectionId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionDetailQueryKey(inspectionId);
    const queryFn = ({ signal }) => getInspectionDetail(inspectionId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionDetail(inspectionId, options) {
    const queryOptions = getGetInspectionDetailQueryOptions(inspectionId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetInspectionDetailSuspenseQueryOptions = (inspectionId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionDetailQueryKey(inspectionId);
    const queryFn = ({ signal }) => getInspectionDetail(inspectionId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionDetailSuspense(inspectionId, options) {
    const queryOptions = getGetInspectionDetailSuspenseQueryOptions(inspectionId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const updateInspection = (inspectionId, updateInspectionBody, options) => {
    return axios.put(`/api/v1/inspections/${inspectionId}`, updateInspectionBody, options);
};
export const getUpdateInspectionMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { inspectionId, data } = props ?? {};
        return updateInspection(inspectionId, data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdateInspection = (options) => {
    const mutationOptions = getUpdateInspectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getAllContacts = (inspectionId, params, options) => {
    return axios.get(`/api/v1/inspections/${inspectionId}/contacts`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetAllContactsQueryKey = (inspectionId, params) => {
    return [`/api/v1/inspections/${inspectionId}/contacts`, ...(params ? [params] : [])];
};
export const getGetAllContactsQueryOptions = (inspectionId, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllContactsQueryKey(inspectionId, params);
    const queryFn = ({ signal }) => getAllContacts(inspectionId, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetAllContacts(inspectionId, params, options) {
    const queryOptions = getGetAllContactsQueryOptions(inspectionId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllContactsSuspenseQueryOptions = (inspectionId, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllContactsQueryKey(inspectionId, params);
    const queryFn = ({ signal }) => getAllContacts(inspectionId, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetAllContactsSuspense(inspectionId, params, options) {
    const queryOptions = getGetAllContactsSuspenseQueryOptions(inspectionId, params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getInspectionSettings = (inspectionId, options) => {
    return axios.get(`/api/v1/inspections/${inspectionId}/settings`, options);
};
export const getGetInspectionSettingsQueryKey = (inspectionId) => {
    return [`/api/v1/inspections/${inspectionId}/settings`];
};
export const getGetInspectionSettingsQueryOptions = (inspectionId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionSettingsQueryKey(inspectionId);
    const queryFn = ({ signal }) => getInspectionSettings(inspectionId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionSettings(inspectionId, options) {
    const queryOptions = getGetInspectionSettingsQueryOptions(inspectionId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetInspectionSettingsSuspenseQueryOptions = (inspectionId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionSettingsQueryKey(inspectionId);
    const queryFn = ({ signal }) => getInspectionSettings(inspectionId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId), ...queryOptions };
};
export function useGetInspectionSettingsSuspense(inspectionId, options) {
    const queryOptions = getGetInspectionSettingsSuspenseQueryOptions(inspectionId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const updateInspectionSettings = (id, updateInspectionSettingsBody, options) => {
    return axios.put(`/api/v1/inspection-settings/${id}`, updateInspectionSettingsBody, options);
};
export const getUpdateInspectionSettingsMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id, data } = props ?? {};
        return updateInspectionSettings(id, data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdateInspectionSettings = (options) => {
    const mutationOptions = getUpdateInspectionSettingsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getInspectionRemoteSubmissionLocationsForShare = (token, params, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/remote-submission-locations`, {
        ...options,
        params: { ...params, ...options?.params },
    });
};
export const getGetInspectionRemoteSubmissionLocationsForShareQueryKey = (token, params) => {
    return [`/api/v1/inspection-share/${token}/remote-submission-locations`, ...(params ? [params] : [])];
};
export const getGetInspectionRemoteSubmissionLocationsForShareQueryOptions = (token, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionRemoteSubmissionLocationsForShareQueryKey(token, params);
    const queryFn = ({ signal }) => getInspectionRemoteSubmissionLocationsForShare(token, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetInspectionRemoteSubmissionLocationsForShare(token, params, options) {
    const queryOptions = getGetInspectionRemoteSubmissionLocationsForShareQueryOptions(token, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetInspectionRemoteSubmissionLocationsForShareSuspenseQueryOptions = (token, params, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionRemoteSubmissionLocationsForShareQueryKey(token, params);
    const queryFn = ({ signal }) => getInspectionRemoteSubmissionLocationsForShare(token, params, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetInspectionRemoteSubmissionLocationsForShareSuspense(token, params, options) {
    const queryOptions = getGetInspectionRemoteSubmissionLocationsForShareSuspenseQueryOptions(token, params, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getInspectionByShareToken = (token, options) => {
    return axios.get(`/api/v1/inspection-share/${token}/share`, options);
};
export const getGetInspectionByShareTokenQueryKey = (token) => {
    return [`/api/v1/inspection-share/${token}/share`];
};
export const getGetInspectionByShareTokenQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionByShareTokenQueryKey(token);
    const queryFn = ({ signal }) => getInspectionByShareToken(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetInspectionByShareToken(token, options) {
    const queryOptions = getGetInspectionByShareTokenQueryOptions(token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetInspectionByShareTokenSuspenseQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInspectionByShareTokenQueryKey(token);
    const queryFn = ({ signal }) => getInspectionByShareToken(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetInspectionByShareTokenSuspense(token, options) {
    const queryOptions = getGetInspectionByShareTokenSuspenseQueryOptions(token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const updateLocation = (locationId, updateLocationBody, options) => {
    return axios.put(`/api/v1/locations/${locationId}`, updateLocationBody, options);
};
export const getUpdateLocationMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { locationId, data } = props ?? {};
        return updateLocation(locationId, data, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdateLocation = (options) => {
    const mutationOptions = getUpdateLocationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getLocationFindings = (locationId, options) => {
    return axios.get(`/api/v1/locations/${locationId}/findings`, options);
};
export const getGetLocationFindingsQueryKey = (locationId) => {
    return [`/api/v1/locations/${locationId}/findings`];
};
export const getGetLocationFindingsQueryOptions = (locationId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLocationFindingsQueryKey(locationId);
    const queryFn = ({ signal }) => getLocationFindings(locationId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(locationId), ...queryOptions };
};
export function useGetLocationFindings(locationId, options) {
    const queryOptions = getGetLocationFindingsQueryOptions(locationId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetLocationFindingsSuspenseQueryOptions = (locationId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLocationFindingsQueryKey(locationId);
    const queryFn = ({ signal }) => getLocationFindings(locationId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(locationId), ...queryOptions };
};
export function useGetLocationFindingsSuspense(locationId, options) {
    const queryOptions = getGetLocationFindingsSuspenseQueryOptions(locationId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getHazardFindings = (inspectionId, hazardId, options) => {
    return axios.get(`/api/v1/inspections/${inspectionId}/hazards/${hazardId}/findings`, options);
};
export const getGetHazardFindingsQueryKey = (inspectionId, hazardId) => {
    return [`/api/v1/inspections/${inspectionId}/hazards/${hazardId}/findings`];
};
export const getGetHazardFindingsQueryOptions = (inspectionId, hazardId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetHazardFindingsQueryKey(inspectionId, hazardId);
    const queryFn = ({ signal }) => getHazardFindings(inspectionId, hazardId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId && hazardId), ...queryOptions };
};
export function useGetHazardFindings(inspectionId, hazardId, options) {
    const queryOptions = getGetHazardFindingsQueryOptions(inspectionId, hazardId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetHazardFindingsSuspenseQueryOptions = (inspectionId, hazardId, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetHazardFindingsQueryKey(inspectionId, hazardId);
    const queryFn = ({ signal }) => getHazardFindings(inspectionId, hazardId, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId && hazardId), ...queryOptions };
};
export function useGetHazardFindingsSuspense(inspectionId, hazardId, options) {
    const queryOptions = getGetHazardFindingsSuspenseQueryOptions(inspectionId, hazardId, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getFindingPhotosBySizeAndLocation = (locationId, size, options) => {
    return axios.get(`/api/v1/locations/${locationId}/finding-photos/${size}`, options);
};
export const getGetFindingPhotosBySizeAndLocationQueryKey = (locationId, size) => {
    return [`/api/v1/locations/${locationId}/finding-photos/${size}`];
};
export const getGetFindingPhotosBySizeAndLocationQueryOptions = (locationId, size, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFindingPhotosBySizeAndLocationQueryKey(locationId, size);
    const queryFn = ({ signal }) => getFindingPhotosBySizeAndLocation(locationId, size, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(locationId && size), ...queryOptions };
};
export function useGetFindingPhotosBySizeAndLocation(locationId, size, options) {
    const queryOptions = getGetFindingPhotosBySizeAndLocationQueryOptions(locationId, size, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetFindingPhotosBySizeAndLocationSuspenseQueryOptions = (locationId, size, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFindingPhotosBySizeAndLocationQueryKey(locationId, size);
    const queryFn = ({ signal }) => getFindingPhotosBySizeAndLocation(locationId, size, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(locationId && size), ...queryOptions };
};
export function useGetFindingPhotosBySizeAndLocationSuspense(locationId, size, options) {
    const queryOptions = getGetFindingPhotosBySizeAndLocationSuspenseQueryOptions(locationId, size, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getFindingPhotosBySizeAndHazard = (inspectionId, hazardId, size, options) => {
    return axios.get(`/api/v1/inspections/${inspectionId}/hazards/${hazardId}/finding-photos/${size}`, options);
};
export const getGetFindingPhotosBySizeAndHazardQueryKey = (inspectionId, hazardId, size) => {
    return [`/api/v1/inspections/${inspectionId}/hazards/${hazardId}/finding-photos/${size}`];
};
export const getGetFindingPhotosBySizeAndHazardQueryOptions = (inspectionId, hazardId, size, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFindingPhotosBySizeAndHazardQueryKey(inspectionId, hazardId, size);
    const queryFn = ({ signal }) => getFindingPhotosBySizeAndHazard(inspectionId, hazardId, size, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId && hazardId && size), ...queryOptions };
};
export function useGetFindingPhotosBySizeAndHazard(inspectionId, hazardId, size, options) {
    const queryOptions = getGetFindingPhotosBySizeAndHazardQueryOptions(inspectionId, hazardId, size, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetFindingPhotosBySizeAndHazardSuspenseQueryOptions = (inspectionId, hazardId, size, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFindingPhotosBySizeAndHazardQueryKey(inspectionId, hazardId, size);
    const queryFn = ({ signal }) => getFindingPhotosBySizeAndHazard(inspectionId, hazardId, size, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(inspectionId && hazardId && size), ...queryOptions };
};
export function useGetFindingPhotosBySizeAndHazardSuspense(inspectionId, hazardId, size, options) {
    const queryOptions = getGetFindingPhotosBySizeAndHazardSuspenseQueryOptions(inspectionId, hazardId, size, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const deletePhoto = (id, options) => {
    return axios.delete(`/api/v1/photos/${id}`, options);
};
export const getDeletePhotoMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};
    const mutationFn = (props) => {
        const { id } = props ?? {};
        return deletePhoto(id, axiosOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useDeletePhoto = (options) => {
    const mutationOptions = getDeletePhotoMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPhotoBySize = (id, size, options) => {
    return axios.get(`/api/v1/photos/${id}/${size}`, options);
};
export const getGetPhotoBySizeQueryKey = (id, size) => {
    return [`/api/v1/photos/${id}/${size}`];
};
export const getGetPhotoBySizeQueryOptions = (id, size, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPhotoBySizeQueryKey(id, size);
    const queryFn = ({ signal }) => getPhotoBySize(id, size, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(id && size), ...queryOptions };
};
export function useGetPhotoBySize(id, size, options) {
    const queryOptions = getGetPhotoBySizeQueryOptions(id, size, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetPhotoBySizeSuspenseQueryOptions = (id, size, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPhotoBySizeQueryKey(id, size);
    const queryFn = ({ signal }) => getPhotoBySize(id, size, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(id && size), ...queryOptions };
};
export function useGetPhotoBySizeSuspense(id, size, options) {
    const queryOptions = getGetPhotoBySizeSuspenseQueryOptions(id, size, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAddressByPostcode = (postcode, options) => {
    return axios.get(`/api/v1/address-finder/${postcode}`, options);
};
export const getGetAddressByPostcodeQueryKey = (postcode) => {
    return [`/api/v1/address-finder/${postcode}`];
};
export const getGetAddressByPostcodeQueryOptions = (postcode, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAddressByPostcodeQueryKey(postcode);
    const queryFn = ({ signal }) => getAddressByPostcode(postcode, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(postcode), ...queryOptions };
};
export function useGetAddressByPostcode(postcode, options) {
    const queryOptions = getGetAddressByPostcodeQueryOptions(postcode, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAddressByPostcodeSuspenseQueryOptions = (postcode, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAddressByPostcodeQueryKey(postcode);
    const queryFn = ({ signal }) => getAddressByPostcode(postcode, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(postcode), ...queryOptions };
};
export function useGetAddressByPostcodeSuspense(postcode, options) {
    const queryOptions = getGetAddressByPostcodeSuspenseQueryOptions(postcode, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getAllLocationsForRemoteSubmission = (token, options) => {
    return axios.get(`/api/v1/remote-submissions/${token}/locations`, options);
};
export const getGetAllLocationsForRemoteSubmissionQueryKey = (token) => {
    return [`/api/v1/remote-submissions/${token}/locations`];
};
export const getGetAllLocationsForRemoteSubmissionQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllLocationsForRemoteSubmissionQueryKey(token);
    const queryFn = ({ signal }) => getAllLocationsForRemoteSubmission(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllLocationsForRemoteSubmission(token, options) {
    const queryOptions = getGetAllLocationsForRemoteSubmissionQueryOptions(token, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetAllLocationsForRemoteSubmissionSuspenseQueryOptions = (token, options) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllLocationsForRemoteSubmissionQueryKey(token);
    const queryFn = ({ signal }) => getAllLocationsForRemoteSubmission(token, { signal, ...axiosOptions });
    return { queryKey, queryFn, enabled: !!(token), ...queryOptions };
};
export function useGetAllLocationsForRemoteSubmissionSuspense(token, options) {
    const queryOptions = getGetAllLocationsForRemoteSubmissionSuspenseQueryOptions(token, options);
    const query = useSuspenseQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
